export const i18nAssetPage = {
  sections: {
    alarms_list: 'Historial de alarmas',
    event_list: 'Historial de eventos',
  },
  components: {
    upload_assets_tree: 'Sin bienes registrados. Comience a crear su árbol de activos.',
    add_asset: 'Agregar activo',
    upload_csv: 'Subir CSV',
    upload_tags: 'Subir tags en CSV',
  },
  message: {
    asset_not_found: {
      title: 'Equipo no encontrado',
      message: 'Intente con un id de equipo válido',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Ha ocurrido un error inesperado. Espera unos minutos e inténtalo de nuevo',
    },
  },
};
